
import { defineComponent, PropType } from 'vue';
import { B2CCreateProfileTileModel } from '@/types/B2CcontentServerContract';
import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';
import CreateProfile from '@/b2c/profile/ui/CreateProfile.vue';

export default defineComponent({
    name: 'B2CCreateProfileTile',
    components: { CreateProfile, BlockMaxWidthHandler },
    props: {
        content: {
            type: Object as PropType<B2CCreateProfileTileModel>,
            required: true,
        },
    },
});
